import { Box, Switch, ToggleButton, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { format } from 'date-fns';
import styles from './TimesheetsToolbar.module.css';

interface TimesheetsToolbarProps {
	employeeName: string;
	selectedDate: Date;
	decimalFormat: boolean;
	setDecimalFormat: (value: boolean) => void;
	loadingEmployees: boolean;
	loadingTimesheetEntries: boolean;
}

const TimesheetsToolbar: React.FC<TimesheetsToolbarProps> = (props) => {
	const {
		employeeName,
		selectedDate,
		decimalFormat,
		setDecimalFormat,
		loadingEmployees,
		loadingTimesheetEntries,
	} = props;

	return (
		<Toolbar disableGutters={true}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', md: 'row' },
					gap: 1,
					justifyContent: { xs: 'left', md: 'space-between' },
					width: '100%',
				}}
			>
				<Typography variant="h6" fontWeight={400} gutterBottom={false}>
					{loadingEmployees ? (
						`Loading Employee Data...`
					) : (
						<>
							{employeeName === '' ? (
								'Select an Employee'
							) : (
								<>
									{loadingTimesheetEntries
										? 'Loading'
										: 'Viewing'}{' '}
									<span className={styles.employeeName}>
										{employeeName}'s
									</span>{' '}
									entries for{' '}
									<span className={styles.date}>
										{format(
											selectedDate,
											'iii, do MMMM yyyy',
										)}
									</span>
								</>
							)}
						</>
					)}
				</Typography>
				<Box>
					<Typography variant="caption" gutterBottom={false}>
						Show Time in Minutes & Hours
					</Typography>
					<Switch
						checked={!decimalFormat}
						color="primary"
						size="medium"
						onChange={() => setDecimalFormat(!decimalFormat)}
					/>
				</Box>
			</Box>
		</Toolbar>
	);
};

export default TimesheetsToolbar;
